import styled from "styled-components";
import {deviceMax} from "../../../styles/device";
import Colors from "../../constants/Colors";

export const CareerContentCompWrapper = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 0 24px;

  @media ${deviceMax.tablet} {
    padding: 0 35px;
  }
`;

export const CareerContentJobPostings = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.white};
  border-radius: 6px;
  margin-bottom: 26px;

  &:last-child {
    margin-bottom: 0;
  }

  @media ${deviceMax.tablet} {
    margin-bottom: 18px;
  }

`;

export const CareerContentJobPostingsTitle = styled.div`
  position: relative;

`;

export const CareerContentJobPostingsDetails = styled.div`
  
  display: none;
  
  @media ${deviceMax.tablet} {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-bottom: 26px;
    padding: 0 0 0 0;
    flex-direction: column;
    align-items: center;
    text-align: center;
    
    &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 1px;
        background: ${Colors.blackColor};
    }
  }
`;

export const CareerContentJobPostingsTitleText = styled.h2`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 55px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: ${Colors.brandColor};
  margin: 0;
  padding: 23px 0 26px 46px;

  @media ${deviceMax.tablet} {
    padding-left: 0;
    margin: 0 auto;
    color: ${Colors.blackColor};
    line-height: 30px;
    letter-spacing: 0;
    text-align: center;
  }
`;

export const CareerContentJobPostingsList = styled.div`
  position: relative;
  padding-left: 34px;
  padding-right: 50px;
  padding-bottom: 59px;

  @media ${deviceMax.tablet} {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
`;

export const CareerContentJobPostingsListItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  @media ${deviceMax.tablet} {
    flex-direction: column;
    align-items: center;
  }
`;

export const CareerContentJobPostingsListItemIcon = styled.div`
  position: relative;

  > img {
    width: 100%;
    height: auto;

    @media ${deviceMax.tablet} {
      max-width: 106px;
    }

  }
`;

export const CareerContentJobPostingsListItemContent = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 60px;

  @media ${deviceMax.tablet} {
    margin-left: 0;
    width: 100%;
    max-width: 300px;
  }
`;

export const CareerContentJobPostingsListItemContentTitle = styled.h2`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${Colors.blackColor};
  margin-bottom: 16px;
  margin-top: 0;

  @media ${deviceMax.tablet} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CareerContentJobPostingsListItemContentDropdown = styled.div`
  position: relative;
  background: ${Colors.purpleColor};
  border-radius: 8px;

  @media ${deviceMax.tablet} {
    background: transparent;
  }

  > select {
    position: relative;
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    text-transform: uppercase;
    color: ${Colors.white};
    background: transparent;
    border: none;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    width: 100%;
    overflow: hidden;

    @media ${deviceMax.tablet} {
      font-weight: 700;
      font-size: 14px;
      line-height: 19px;
    }
    
    @media ${deviceMax.mobileM} {
        font-size: 12px;
    }

    > option {
      color: ${Colors.white};
    }
  }

  > img {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);

    @media ${deviceMax.tablet} {
      right: 15px;
    }
  }
  
  > .career-select {
    position: relative;
    padding: 10px 20px;
    font-family: Manrope, sans-serif;
    
    
    @media ${deviceMax.tablet} {
      background: ${Colors.brandColor};
      border-radius: 36px;
    }
  }
`;

export const CareerContentJobTitle = styled.div`
  position: relative;
`;

export const CareerContentJobTitleText = styled.h2`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 55px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: ${Colors.purpleColor};
  margin: 0;
  padding-top: 37px;
  padding-left: 56px;
  padding-bottom: 10px;

  @media ${deviceMax.tablet} {
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin: 0 auto;
    text-align: center;
    line-height: 35px;
  }
`;

export const CareerContentJobListItem = styled.div`
  position: relative;
  padding: 0 56px 20px 56px;

  @media ${deviceMax.tablet} {
    padding: 0 0 24px 0;

    &:last-child {
      padding-bottom: 0;
    }
  }
`;

export const CareerContentJobListItemContentTitle = styled.div`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${Colors.brandColor};
  margin-bottom: 30px;

  @media ${deviceMax.tablet} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }
`;

export const CareerContentJobListItemContentText = styled.div`
  position: relative;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${Colors.blackColor};
  margin-bottom: 30px;

  @media ${deviceMax.tablet} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }
`;

export const CareerContentJobListItemLink = styled.a`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${Colors.blackColor};
  text-decoration: underline;

  @media ${deviceMax.tablet} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

